import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import '@fontsource-variable/outfit'
import './index.css'
import App from './App.tsx'
import { initTheme } from './theme'

// Initialize theme from localStorage (light default)
initTheme()

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#111111',
              color: '#fff',
              borderRadius: 999,
              padding: '10px 18px',
              fontFamily: "'Outfit Variable', 'Outfit', system-ui, sans-serif",
              fontSize: 14,
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#ea580c',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#fb923c',
                secondary: '#fff',
              },
            },
          }}
        />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
